import type { ComputedRef, MaybeRefOrGetter } from "vue";
import { computed, inject, toValue, useId } from "vue";

export const FIELD_ID_KEY = "FieldId";

interface UseFieldIdOptions {
  /** Controls that often repeat inside one field (radios, checkboxes, switches) must not take the field's id. */
  inheritFieldId?: boolean
}

/**
 * The id of a form control, which its `<label for>` and its error and hint ids point at.
 * The caller's id wins, then the id provided by a surrounding field, then an id unique to this instance.
 */
export function useFieldId(
  explicitId: MaybeRefOrGetter<string | null | undefined>,
  { inheritFieldId = true }: UseFieldIdOptions = {},
): ComputedRef<string> {
  const injectedId = inheritFieldId ? inject<string | null>(FIELD_ID_KEY, null) : null;
  const instanceId = useId();

  return computed(() => toValue(explicitId) || injectedId || instanceId);
}
